/*
 * @Author: Json Chen
 * @Date: 2021-07-13 15:14:40
 * @LastEditTime: 2021-10-27 16:49:22
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/type.ts
 */

export enum CourierType {
  SF = 'SF',
  ZTO = 'ZTO',
}

export enum SFLocation {
  HK_MO = 'HK_MO',
  CN = 'CN',
  GLOBAL = 'GLOBAL',
}

export enum CourierAccountType {
  QSF = 'QSF',
  ZTO = 'ZTO',
  SF_GLOBAL = 'SF_GLOBAL',
}
